import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-md hover:shadow-lg active:scale-95 cursor-pointer';
  const variants = {
    primary: 'bg-[#D4A017] hover:bg-[#F5C842] text-[#5C3D2E]',
    secondary: 'bg-[#5B7A3A] hover:bg-[#4a632f] text-white',
    outline: 'bg-transparent border-2 border-[#5C3D2E] text-[#5C3D2E] hover:bg-[#5C3D2E] hover:text-white'
  };
  const sizes = {
    md: 'px-6 py-3 text-lg',
    lg: 'px-8 py-4 text-xl',
    xl: 'px-10 py-5 text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-121">
      {children}
    </motion.button>;
}